import React from "react";
import { TbLoader } from "react-icons/tb";
import BluefieldLogo from "./assets/logo.png";

export const Spinner = () => {
  return (
    <div className="loader-backdrop">
      <div className="circular-loader">
        <div className="loader-ring" />
        <img
          src={BluefieldLogo}
          alt="Loading"
          className="bluefield-logo-center"
        />
      </div>
    </div>
  );
};
